"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WolfEditCarExcessWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var ExcessExplainedRenderers_1 = require("../../../components/modals/renderers/ExcessExplainedRenderers");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var AnnualMotorGlassAndRepairExcessWordingGenerator_1 = require("../../../helpers/annual/motor/AnnualMotorGlassAndRepairExcessWordingGenerator");
var WolfEditCarExcessWidget = exports.WolfEditCarExcessWidget = /** @class */ (function (_super) {
    __extends(WolfEditCarExcessWidget, _super);
    function WolfEditCarExcessWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showPopup: false
        };
        _this.togglePopUp = _this.togglePopUp.bind(_this);
        return _this;
    }
    WolfEditCarExcessWidget.prototype.render = function () {
        var vehicle = this.props.interaction.vehicles[0];
        return (React.createElement("div", { className: "edit-car-excess-widget ".concat(this.getSetting("cssClass", "")) },
            React.createElement("h4", { className: "excess-heading" },
                React.createElement("div", null,
                    "Excesses that apply",
                    React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Excess explained" }, (0, ExcessExplainedRenderers_1.renderWolfEditCarExcessExplained)(vehicle.annualVehicleExcess)))),
            React.createElement("div", { className: "text-center" },
                React.createElement("p", { className: "mb-0" }, "Accidental damage:\u00A0"),
                React.createElement("p", { className: "wolf-excess-table-head-text font-weight-semi-bold" }, "\u00A3".concat(vehicle.annualVehicleExcess.compulsoryExcess + vehicle.annualVehicleExcess.voluntaryExcess),
                    React.createElement("span", null, " (this includes \u00A3".concat(vehicle.annualVehicleExcess.voluntaryExcess, " voluntary excess)"))),
                React.createElement("p", { className: "mb-0 mt-4" }, "Fire or theft:\u00A0"),
                React.createElement("p", { className: "wolf-excess-table-head-text font-weight-semi-bold" }, "\u00A3".concat(vehicle.annualVehicleExcess.compulsoryExcess + vehicle.annualVehicleExcess.voluntaryExcess),
                    React.createElement("span", null, " (this includes \u00A3".concat(vehicle.annualVehicleExcess.voluntaryExcess, " voluntary excess)"))),
                React.createElement("div", { className: "mb-4 mt-4" }, "Your total excess applies every time you claim and to every car you\u2019re claiming on."),
                AnnualMotorGlassAndRepairExcessWordingGenerator_1.AnnualMotorGlassAndRepairExcessWordingGenerator.getGlassAndRepairExcessWording(vehicle))));
    };
    WolfEditCarExcessWidget.prototype.togglePopUp = function () {
        this.setState(function (state) { return ({
            showPopup: !state.showPopup
        }); });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], WolfEditCarExcessWidget.prototype, "changelogRecorder", void 0);
    return WolfEditCarExcessWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=WolfEditCarPanelExcessWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/WolfEditCarPanelExcessWidget.js
// module id = 3216
// module chunks = 0